import React from 'react';
import AccountHoldersPage from '../features/accountHolders/pages/AccountHoldersPage';

const AccountHolders: React.FC = () => <AccountHoldersPage />;

export default AccountHolders;
